import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/dashboard/balance/long-term-liabilities",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
